import { PermissionEnum, Response } from '@ui/src';
import api from '../../api/api';

export interface PermissionResponse {
  permissions: PermissionEnum[];
}

export const messagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMessagesPermissions: build.query<{ data: PermissionResponse }, void>({
      query: () => ({
        url: '/v1/employees/whoami',
      }),
    }),
    getMessagingTransactionTypes: build.query<
      Response<{ name: string; id: string }>,
      void
    >({
      query: () => ({
        url: '/v1/transactions-types?all=true',
      }),
    }),
    getMessagingWhitelabel: build.query<
      {
        data: {
          data: {
            value: Record<string, string>;
          };
        };
      },
      void
    >({
      query: () => ({
        url: '/v1/settings/whitelabel',
      }),
    }),
  }),
});

export const {
  useLazyGetMessagesPermissionsQuery,
  useLazyGetMessagingTransactionTypesQuery,
  useLazyGetMessagingWhitelabelQuery,
} = messagesApi;

export const {
  endpoints: { getMessagesPermissions, getMessagingTransactionTypes },
} = messagesApi;
